import { Component, OnDestroy, Input, TemplateRef, ContentChild } from '@angular/core';
import { ICellRendererParams } from 'ag-grid-community';

import { ICellRendererAngularComp } from 'ag-grid-angular';


@Component({
	selector: 'btn-cell-renderer-edit-delete',
	template:

	`
	<em *ngIf="enableEdit">
	<img style="cursor:pointer;"
	src="./assets/images/edit_blue.svg" 
	(click)="btnClickedHandler('edit')"
	style="height: 18px;width: 18px;"> 
	</em>

	<em *ngIf="PDFprint">
	<img style="cursor:pointer; width:20px; height:20px;"
	src="./assets/images/printer-svgrepo-com.svg" 
	(click)="btnClickedHandler('print')"> 
	</em>
	
	<em *ngIf="enableReopen">
	<img [style]="pageName? 'margin-left: 10px;cursor:pointer;' : 'margin-left:14px;cursor:pointer;'" src="./assets/images/reopen.png" 
	(click)="btnClickedHandler('reopen')"
	style="height: 18px;width: 18px;">  
	</em>

	<em *ngIf="enableDelete">
	<img [style]="pageName? 'margin-left: 10px;cursor:pointer;' : 'margin-left:14px;cursor:pointer;'"  src="./assets/images/delete_red.svg" 
	(click)="btnClickedHandler('delete')"
	style="height: 18px;width: 18px;">
	</em>
	
	<em *ngIf="enableNavigate">
	<img [style]="pageName? 'margin-left: 10px;cursor:pointer;' : 'margin-left:14px;cursor:pointer;'"  src="./assets/images/navigatetopage.png" 
	(click)="btnClickedHandler('navigate')"
	style="height: 18px;width: 18px;">
	</em>`	
})
export class BtnCellRendererEditDelete implements ICellRendererAngularComp, OnDestroy {



	refresh(params: ICellRendererParams): boolean {
		throw new Error(`Error while refreshing renderer component. INFO-${params}`);
	}

	private params: any;
	pageName!: string;
	enableEdit: boolean = true;
	enableDelete: boolean = true;
    PDFprint: boolean = false;
	enableReopen: boolean = false;
	enableNavigate: boolean = false;

	agInit(params: any): void {
		this.params = params;
		this.pageName = this.params.colDef.field;

		//tier
		if (this.pageName == "user-management") {
			this.enableEdit = true;
			this.enableDelete = false;
		}
		else if (this.pageName == "compliance-management") {
			this.enableEdit = true;
			this.enableDelete = false;
		}
		else if (this.pageName == "upload-info") {
			if (this.params.data.status == 'CLOSE') {
				this.enableEdit = true;
				this.enableDelete = false;
			}
		}
		else if (this.pageName == "container-consolidation") {
			this.enableEdit = true;
			this.enableDelete = true;
		}
		else if (this.pageName == "PDF-print") {
			this.PDFprint = true;
			this.enableEdit = false;
			this.enableDelete = false;
		}
		else if (this.pageName == "load-type") {
			if(this.params.data.status == 'CLOSE')
			{
			this.enableEdit = false;
			this.enableDelete = false;
			}
		}else if (this.pageName == "container-consolidation-Close") {
			if(this.params.data.status == 'CLOSE')
			{
				if(this.params.data.reOpenStatus == 'ACTIVE'){
					this.enableEdit = false;
					this.enableDelete = false;
					this.enableReopen = true;
				}
				else
				{
					this.enableEdit = false;
					this.enableDelete = false;
					this.enableReopen = false;
				}
			}
		}
		else if (this.pageName == "laneSummary") {
			this.enableEdit = false;
			this.PDFprint = false;
			this.enableDelete = false;
			this.enableReopen = false;
			this.enableNavigate = true;
		}
		else {
			this.enableEdit = true;
			this.enableDelete = true;
		}

	}

	btnClickedHandler(action: string) {
		if (action == 'edit') {
			this.params.context.componentParent.editTemplateRow(this.params.data);
		}
		if (action == 'delete') {
			this.params.context.componentParent.deleteTemplateRow([this.params.data]);
		}
		if (action == 'print') {
			this.params.context.componentParent.printPDFTemplateRow(this.params.data);
		}
		if (action == 'reopen') {
			this.params.context.componentParent.reopenTemplateRow([this.params.data]);
		}		
		if (action == 'navigate') {
			this.params.context.componentParent.navigateTemplateRow([this.params.data]);
		}	
	}

	ngOnDestroy() {

	}
}